import { Dimensions, StyleSheet } from 'react-native';
import { Colors } from 'react-native-paper';
import { appColors } from '../../../assets/styles/global';
import { pixelDimensions } from '../../../config/utils';

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    marginTop: pixelDimensions(2),
    flex: 1,
    justifyContent: 'space-between',
  },
  viewEvaluation: {
    marginHorizontal: pixelDimensions(2),
    alignItems: 'center',
  },
  starLight: {
    color: Colors.black,
  },
  buttonConfirm: {
    backgroundColor: appColors.primary,
    paddingVertical: pixelDimensions(2),
    paddingHorizontal: pixelDimensions(6),
    marginHorizontal: pixelDimensions(4),
    marginVertical: pixelDimensions(2),
  },
  buttonBack: {
    alignSelf: 'flex-end',
    backgroundColor: appColors.primary,
    paddingVertical: pixelDimensions(2),
    paddingHorizontal: pixelDimensions(6),
    marginHorizontal: pixelDimensions(4),
    marginVertical: pixelDimensions(2),
  },
  textBack: {
    color: Colors.white,
    fontSize: pixelDimensions(4.5),
  },
  textTitle: {
    fontSize: pixelDimensions(6),
    fontFamily: 'MBold',
  },
  textSubTitle: {
    fontSize: pixelDimensions(5),
    fontFamily: 'MBold',
  }
});

export default styles;
